import { render } from "./BidShowcaseZaymelo.vue?vue&type=template&id=a0f4efc4&scoped=true"
import script from "./BidShowcaseZaymelo.vue?vue&type=script&lang=js"
export * from "./BidShowcaseZaymelo.vue?vue&type=script&lang=js"

import "./BidShowcaseZaymelo.vue?vue&type=style&index=0&id=a0f4efc4&scoped=true&lang=css"
import "./BidShowcaseZaymelo.vue?vue&type=style&index=1&id=a0f4efc4&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f4efc4"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QSelect,QForm,QInput});
